import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { LogoMark } from "@/components/Logo";
import Login from "@/pages/Login";
import Kiosco from "@/pages/Kiosco";
import SubirMovil from "@/pages/SubirMovil";
import PanelLayout from "@/layouts/PanelLayout";
import HoyPage from "@/pages/rrhh/Hoy";
import AlertasPage from "@/pages/rrhh/Alertas";
import FichadasPage from "@/pages/rrhh/Fichadas";
import JustificativosPage from "@/pages/rrhh/Justificativos";
import CalendarioPage from "@/pages/rrhh/Calendario";
import EmpleadosPage from "@/pages/rrhh/Empleados";
import FichaEmpleadoPage from "@/pages/rrhh/FichaEmpleado";
import HistorialPage from "@/pages/rrhh/Historial";
import ExportarPage from "@/pages/rrhh/Exportar";
import DemoRelojPage from "@/pages/rrhh/DemoReloj";
import LiquidacionMesPage from "@/pages/liquidacion/Resumen";
import DetallePersonaPage from "@/pages/liquidacion/DetallePersona";
import AjustesPage from "@/pages/liquidacion/Ajustes";
import CierresPage from "@/pages/liquidacion/Cierres";

function Splash() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background" data-testid="splash">
      <div className="animate-pulse">
        <LogoMark size={52} />
      </div>
    </div>
  );
}

function destino(rol) {
  return rol === "kiosco" ? "/kiosco" : rol === "rrhh" ? "/rrhh/hoy" : "/liquidacion/resumen";
}

function RoleRedirect() {
  const { user } = useAuth();
  if (user === undefined) return <Splash />;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={destino(user.rol)} replace />;
}

function RequireRole({ roles, children }) {
  const { user } = useAuth();
  if (user === undefined) return <Splash />;
  if (!user) return <Navigate to="/login" replace />;
  if (!roles.includes(user.rol)) return <Navigate to={destino(user.rol)} replace />;
  return children;
}

function App() {
  return (
    <div className="App min-h-screen bg-background text-foreground">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<RoleRedirect />} />
            <Route path="/login" element={<Login />} />
            <Route path="/subir/:token" element={<SubirMovil />} />
            <Route path="/kiosco" element={<RequireRole roles={["kiosco"]}><Kiosco /></RequireRole>} />
            <Route path="/rrhh" element={<RequireRole roles={["rrhh"]}><PanelLayout rol="rrhh" /></RequireRole>}>
              <Route index element={<Navigate to="hoy" replace />} />
              <Route path="hoy" element={<HoyPage />} />
              <Route path="alertas" element={<AlertasPage />} />
              <Route path="fichadas" element={<FichadasPage />} />
              <Route path="justificativos" element={<JustificativosPage />} />
              <Route path="calendario" element={<CalendarioPage />} />
              <Route path="empleados" element={<EmpleadosPage />} />
              <Route path="empleados/:id" element={<FichaEmpleadoPage />} />
              <Route path="historial" element={<HistorialPage />} />
              <Route path="exportar" element={<ExportarPage />} />
            </Route>
            <Route path="/demo-reloj" element={<RequireRole roles={["rrhh"]}><PanelLayout rol="rrhh" /></RequireRole>}>
              <Route index element={<DemoRelojPage />} />
            </Route>
            <Route path="/liquidacion" element={<RequireRole roles={["liquidacion"]}><PanelLayout rol="liquidacion" /></RequireRole>}>
              <Route index element={<Navigate to="resumen" replace />} />
              <Route path="resumen" element={<LiquidacionMesPage />} />
              <Route path="persona/:id" element={<DetallePersonaPage />} />
              <Route path="ajustes" element={<AjustesPage />} />
              <Route path="cierres" element={<CierresPage />} />
              <Route path="calendario" element={<CalendarioPage />} />
              <Route path="hoy" element={<HoyPage />} />
              <Route path="fichadas" element={<FichadasPage />} />
              <Route path="justificativos" element={<JustificativosPage />} />
              <Route path="empleados" element={<EmpleadosPage />} />
              <Route path="historial" element={<HistorialPage />} />
            </Route>
            <Route path="*" element={<RoleRedirect />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="top-center" />
      </AuthProvider>
    </div>
  );
}

export default App;
